const HOST = window.location.hostname;
const PROTOCOL = window.location.protocol;
const API_URL = `${PROTOCOL}//${HOST}`;
const APP_URL = `${PROTOCOL}//${HOST}`;
export { API_URL, APP_URL };